/**
 * isiXhosa: Templates
 *
 * What this file covers: WhatsApp message templates and Meta's approval of them.
 *
 * Tone: Precise. Keep Meta's terms consistent (template, category, approved, rejected, paused). Explain Meta's
 * rules plainly, without blame.
 *
 * isiXhosa: Everyday isiXhosa as used in South African business. Keys not translated yet fall back to English,
 * so a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const templates: Catalog = {
  'templates.title': 'Iitemplethi',
  'templates.actions.saveDraft': 'Gcina uyilo',
  'templates.columns.category': 'Udidi',
  'templates.columns.note': 'Inqaku',
  'templates.empty': 'Akukho template okwangoku.',
  'templates.loadError': 'Ayikwazanga ukulayisha iitemplethi.',
  'templates.modal.delete.title': 'Cima itemplethi?',
  'templates.toast.submitFailed': 'Ukungenisa kusilele',
  'templates.view.backToAll': 'Zonke iitemplethi',
  'templates.view.notFound': 'Itemplethi ayifunyanwanga.',
  'templates.view.overview.metadata': 'Imethadatha',
  'templates.view.overview.preview': 'Imboniso kuqala',
  'templates.view.tabs.components': 'Iinxalenye',
  'templates.view.tabs.variables': 'Iiguqulwayo',
  'templates.actions.create': 'Yenza itemplethi',
  'templates.showingOf': 'Kuboniswa {{count}} kwezingu-{{total}}',
  'templates.note.underReview': 'Iphononongwa yiMeta.',
  'templates.view.overview.businessName': 'Ishishini lakho',
  'templates.view.overview.composer': 'Chwetheza umyalezo',
  'templates.header.label': 'Isihloko',
  'templates.header.format.none': 'Akukho sihloko',
  'templates.header.format.text': 'Umbhalo',
  'templates.header.format.image': 'Umfanekiso',
  'templates.header.format.video': 'Ividiyo',
  'templates.header.format.document': 'Uxwebhu'
};

export default templates;
